import PropTypes from 'prop-types';
import { Button, DialogActions } from '@mui/material';
import { dialogActionSx, dialogButtonSx } from '../../Common/components/Styles/InputStyles';

const CommonDialogActions = ({
  onCancel,
  onSubmit,
  submitText,
  disabled
}) => (
  <DialogActions sx={dialogActionSx}>
    <Button
      size="medium"
      onClick={onCancel}
      sx={dialogButtonSx.cancel}>
      Cancel
    </Button>

    <Button
      variant="contained"
      size="medium"
      disabled={disabled}
      onClick={onSubmit}
      sx={dialogButtonSx.primary}>
      {submitText}
    </Button>
  </DialogActions>
);

CommonDialogActions.propTypes = {
  disabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  submitText: PropTypes.string
};

export default CommonDialogActions;